/*
 * @Author: mazhigang
 * @Date: 2023-04-23 10:45:21
 * @LastEditors: mazhigang
 * @LastEditTime: 2024-01-14 18:56:35
 */
import Vue from "vue";
import axios from "axios";
import router from "../router";
import { Message } from "element-ui";

Vue.prototype.$version = "1.1.61";
/*第一层if判断生产环境和开发环境*/
if (process.env.NODE_ENV === "production") {
  console.log(process.env.VUE_APP_FLAG);
  Vue.prototype.$baseUrl =
    window.location.protocol + "//" + window.location.hostname + "/";
  Vue.prototype.environment = "";
} else {
  //dev 开发环境
  Vue.prototype.$baseUrl = "https://h-uat.baoanlailou.com/";
  // Vue.prototype.$baseUrl = "http://http://192.168.3.38:9092/";
  // Vue.prototype.$baseUrl = "http://192.168.6.9:9002/"; //飞哥
  Vue.prototype.environment = "/dev-api";
}
const instance = axios.create({
  baseURL: Vue.prototype.environment,
  requestUrl: Vue.prototype.$baseUrl,
  withCredentials: false,
  responseType: ""
});

instance.interceptors.request.use(
  config => {
    if (config.headers["terminal-type"] === undefined) {
      config.headers["terminal-type"] = 2;
    }
    // 请求级 config 传 noToken: true 时不携带登录态头（免登录接口用）
    if (config.noToken !== true) {
      config.headers["x-sec-m-token"] = localStorage.getItem("TOKEN");
    }
    config.headers["gade-api-version"] = Vue.prototype.$version;
    config.headers["client-type"] = "h5";
    config.headers["Content-Type"] = "application/json; charset=utf-8";
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  function(response) {
    // 处理响应数据
    if (parseInt(response.data.respCode) !== 0) {
      if (parseInt(response.data.respCode)) {
        if (parseInt(response.data.respCode) == 401) {
          router.push("/login");
        }
        if (parseInt(response.data.respCode) == 60102) {
          Message({
            message: "您已经注册了账号，请使用App进行登录使用",
            type: "warning",
            duration: 2 * 1000
          });
          setTimeout(() => {
            router.push("/poster");
          }, 2000);

          return;
        }
        Message({
          message: response.data.respMsg || "Error",
          type: "warning",
          duration: 2 * 1000
        });
      } else {
        return response;
      }
      return Promise.reject(response);
    } else {
      return response.data;
    }
  },
  function(error) {
    // 处理响应失败
    return Promise.reject(error);
  }
);

Vue.prototype.$axios = instance;
export default instance;



// WEBPACK FOOTER //
// ./src/api/axios.js